<!-- <div class="gototop" (click)="pageScroller()"><img src="../../../assets/icon/gototop.svg" /></div> -->
<app-top-header></app-top-header>
<ion-content #pageTop class="app-free-game" (click)="touch()">
  @if (internetMessage) {
    <div class="internet-wrapper">
      <ion-row>
        <ion-col size="10">
          <span>{{internetMessage}}</span>
        </ion-col>
        <ion-col size="2" style="text-align: center">
          <ion-icon name="close-circle" (click)="hideInternetSpeedMsg()"></ion-icon>
        </ion-col>
      </ion-row>
    </div>
  }
  <ion-grid fixed class="game-container">
    @if (userBalanceDetails$ | async; as userDetails) {
      <ion-row class="game-profile">
        <ion-col (click)="openTT()">
          <div class="profile-pic">
            <div class="pf-img">
              <img onError="this.src='../../../assets/images/usericon_profile_signup.svg'"
                src="{{userDetails?.profile_picture}}" class="img-profile" alt="" />
              </div>
            </div>
            <div class="pf-ic-count">
              <ion-img
                src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/tabs_assets%2FPointIcon_800x800.png?alt=media"
              class="ic-img"></ion-img>
              <span class="ic-num-count">{{userDetails?.points | number}}</span>
            </div>
          </ion-col>
          @if (show$ | async) {
            <div class="tooltip-wrapper">
              @if (gameToolTip | async; as tooltip) {
                <div class="tooltip-icon">
                  <span class="tooltip-ic">{{tooltip[0]?.icon}}</span>
                </div>
                <div class="tooltip-content">
                  <h3 class="tooltip-title">
                    {{tooltip[0]?._title && tooltip[0]?._title[selectedLanguage] ? tooltip[0]?._title[selectedLanguage] :
                    tooltip[0]?.title }}
                  </h3>
                  <p class="tooltip-desc">
                    {{tooltip[0]?._description && tooltip[0]?._description[selectedLanguage] ?
                    tooltip[0]?._description[selectedLanguage] : tooltip[0]?.description}}
                  </p>
                </div>
              }
            </div>
          }
        </ion-row>
      } @else {
        <app-in-progress-animation type="loadingUser"></app-in-progress-animation>
      }

      <ng-template #loadingUser>
        <app-in-progress-animation type="loadingUser"></app-in-progress-animation>
      </ng-template>

      <!-- <ion-row class="game-slider" *ngIf="(gamesSlide$ | async) as gamesSlide else loadingSlider">
      <ion-slides class="slider1" [options]="slideOpts">
        <ion-slide *ngFor="let gameBlog of gamesSlide">
          <img src="{{gameBlog?.image}}" class="slider-img" alt="" />
          <div class="overlay-layer" (click)="showMessagePopup()"></div>
          <div class="overlay-content">
            <h4 class="overlay-img-title">
              {{gameBlog?._title && gameBlog?._title[selectedLanguage] ? gameBlog?._title[selectedLanguage] :
              gameBlog?.title}}
            </h4>
          </div>
        </ion-slide>
      </ion-slides>
    </ion-row> -->
    <ng-template #loadingSlider>
      <ion-row class="game-slider">
        <app-in-progress-animation type="loadingSlider"></app-in-progress-animation>
      </ion-row>
    </ng-template>

    @if ((userYoursToPlay$ | async); as userYoursToPlay) {
      <ion-row class="prize-card-wrapper gamz-card">
        @if (userYoursToPlay && userYoursToPlay?.length > 0) {
          <h3 class="title-heading">{{'game.play' | translate}}</h3>
          <ion-row class="y2p-slide-row">
            <swiper class="y2p-slider" [config]="y2pslideOpts" #YoursToPlaySlider>
              @for (yourPlay of (userYoursToPlay | filterYoursToPlay : 1) ; track yourPlay; let i = $index) {
                @for (game of yourPlay; track game) {
                  @if (game?.game_id==prizeUnlockID && game?.play_count > 0) {
                    <ng-template swiperSlide>
                      <div class="item-card-container">
                        <ion-row class="item-row">
                          <div class="img-container">
                            <img src="{{game?.details?.game_icon_url}}" class="item-img"
                              (click)="openPopup($event,game?.details, 'y2p')  " />
                              <span class="game-title test">{{ game?.details?.country_code_data?.[preferredCurrency=='CAD'? 1
                                : preferredCurrency=='EUR'?
                                353 : 44]?.game_title.replace('[prize_number]',game?.play_count + (game?.play_count>1?'
                              Prizes':' Prize')) }}</span>
                            </div>
                          </ion-row>
                        </div>
                      </ng-template>
                    }
                    @if (game?.game_id!=prizeUnlockID) {
                      <ng-template swiperSlide>
                        <div class="item-card-container">
                          <ion-row class="item-row">
                            <span class="play-count">{{game?.play_count}}</span>
                            <div class="img-container">
                              <img src="{{game?.details?.game_icon_url}}" class="item-img"
                                (click)="openPopup($event,game?.details, 'y2p')  " />
                                <span class="game-title">{{ game?.details?.country_code_data?.[preferredCurrency=='CAD'? 1 :
                                  preferredCurrency=='EUR'?
                                353 : 44]?.game_title}}</span>
                              </div>
                            </ion-row>
                          </div>
                        </ng-template>
                      }
                    }
                  }
                </swiper>
              </ion-row>
            }
          </ion-row>
        } @else {
          <ion-row class="prize-card-wrapper gamz-card">
            <app-in-progress-animation type="loadingY2p"></app-in-progress-animation>
          </ion-row>
        }
        <!-- page navigation -->
        <div class="nav-icon">
          <div class="navigation-arrows">
            <button (click)="prev('yourPlay')" class="nav-prev-icon">
              <ion-icon name="chevron-back-outline"></ion-icon>
            </button>
          </div>
          <div class="navigation-arrows">
            <div class="swiper-pagination_"></div>
          </div>
          <div class="navigation-arrows">
            <button (click)="next('yourPlay')" class="nav-next-icon">
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </button>
          </div>
        </div>
        <ng-template #loadingY2p>
          <ion-row class="prize-card-wrapper gamz-card">
            <app-in-progress-animation type="loadingY2p"></app-in-progress-animation>
          </ion-row>
        </ng-template>

        @if (yourToPlayRecomandation$ | async; as recommendations) {
          <ion-row class="prize-card-wrapper gamz-card"
            >
            @if (recommendations && recommendations?.length > 0) {
              <h3 class="title-heading">
                {{(userBalanceDetails$ | async)?.profile_nickname}}{{(userBalanceDetails$ | async)?.profile_nickname ?
                ',':''}} {{'game.love' | translate}}
              </h3>
              <h4 class="sub-heading">{{'game.favorite' | translate}}</h4>
              <ion-row class="game-slide-row">
                <swiper class="game-slider" [config]="slideOpts" #yoursloveGameSlider>
                  @for (instantWin of (recommendations | filterYoursToPlay : 3) ; track instantWin; let i = $index) {
                    <ng-template swiperSlide
                      >
                      <div class="item-card-container">
                        @for (game of instantWin; track game) {
                          <ion-row class="item-row" (click)="openPopup($event, game.gameData)">
                            <ion-col class="item-icon">
                              <img src="{{game?.gameData?.game_icon_url}}" class="item-img" />
                            </ion-col>
                            <ion-col class="item-details">
                              <ion-row class="item-detail-row">
                                <ion-col class="item-left">
                                  <h5 class="item-title">{{game?.gameData?.game_title}}</h5>
                                  <p class="item-p">{{game?.gameData?.game_short_title}}</p>
                                </ion-col>
                                <ion-col class="item-right">
                                  <div class="prize-txt">Prize</div>
                                  @if (game?.gameData?.country_code_data['44']?.game_title!=starDisplay) {
                                    <div class="money-bag">
                                      <img src="assets/images/money-dollar.png" class="money-bag-img" />
                                    </div>
                                  }
                                  @if (game?.gameData?.country_code_data['44']?.game_title==starDisplay) {
                                    <div class="money-bag">
                                      <img src="assets/images/star.svg" class="money-bag-img" />
                                    </div>
                                  }
                                  @if (game && game.gameData && game.gameData.category=='Instant Win') {
                                    <div class="dollar-wrap">
                                      {{ game?.gameData?.top_prize?.toString().replace("Cash", "") }}
                                    </div>
                                  }
                                  @if (game && game.gameData && game.gameData.category=='Skill' &&  game.gameData?.country_code_data) {
                                    <div class="dollar-wrap"
                                      >
                                      {{ game?.gameData?.total_prize?.toString().replace("Cash", "") }}
                                    </div>
                                  }
                                </ion-col>
                              </ion-row>
                            </ion-col>
                          </ion-row>
                        }
                      </div>
                    </ng-template>
                  }
                </swiper>
              </ion-row>
            }
          </ion-row>
        } @else {
          <ion-row class="prize-card-wrapper gamz-card">
            <app-in-progress-animation type="loadingRec"></app-in-progress-animation>
          </ion-row>
        }
        <!-- page navigation -->
        <div class="nav-icon">
          <div class="navigation-arrows">
            <button (click)="prev('yoursloveGame')" class="nav-prev-icon">
              <ion-icon name="chevron-back-outline"></ion-icon>
            </button>
          </div>
          <div class="navigation-arrows">
            <div class="swiper-pagination-one"></div>
          </div>
          <div class="navigation-arrows">
            <button (click)="next('yoursloveGame')" class="nav-next-icon">
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </button>
          </div>
        </div>
        <ng-template #loadingRec>
          <ion-row class="prize-card-wrapper gamz-card">
            <app-in-progress-animation type="loadingRec"></app-in-progress-animation>
          </ion-row>
        </ng-template>

        @if (userAdventure$ | async; as userAdventure) {
          <ion-row class="adventures-card">
            @if (userAdventure.games && userAdventure.games?.length > 0) {
              <h3 class="title-heading" (click)="openAdventureDetails()">{{userAdventure?.title}}</h3>
              <h4 class="sub-heading">{{userAdventure?.sub_title}}</h4>
              <swiper class="adventure-slider" [config]="adventureSlide" #adventureGameSlide>
                @for (adventure of userAdventure?.games; track adventure) {
                  @if (adventure?.userAdventure?.adventure_mod?.toLowerCase() === 'purchase' ) {
                    <ng-template swiperSlide class="slide-wrapper card-1">
                      <h4 class="card-title">
                        {{adventure?.country_code_data?.[preferredCurrency=='CAD'? 1 : preferredCurrency=='EUR'? 353 :
                        44]?.adventure_title }}
                      </h4>
                      <ion-row class="adventure-row">
                        <ion-col class="img-col">
                          <img (click)="openAdventureDetails(adventure?.adventure_id)" [src]="adventure?.adventure_image_url"
                            alt="" class="gamz-img" />
                            <div class="prize-wrap">
                              <img src="assets/images/discount.png" alt="" class="prize-img" />
                              <div class="prize-txt">
                                {{'game.Prizes' | translate}}<br />
                                {{ adventure?.country_code_data?.[preferredCurrency=='CAD'? 1 : preferredCurrency=='EUR'? 353 :
                                44]?.general_total_prize}}
                              </div>
                            </div>
                          </ion-col>
                          <ion-col class="details-col">
                            <p class="desc-p">
                              {{adventure?.country_code_data?.[preferredCurrency=='CAD'? 1 : preferredCurrency=='EUR'? 353 :
                              44]?.adventure_details | slice:0:42}}
                            </p>
                            <div class="game-boxs">
                              @for (subGame of adventure?.sub_game; track subGame) {
                                <ng-container class="box-card">
                                  <img [src]="subGame" class="box-img" />
                                </ng-container>
                              }
                            </div>
                            <div class="bottow-wrap">
                              @if (adventure.inProgress) {
                                <ion-spinner name="lines-small" class="sign-in-spinner"
                                duration="2000" style="color: blue; margin-right: 1vh"></ion-spinner>
                              }
                              @if (!adventure?.inProgress) {
                                <div class="start-badge" (click)="startAdventure(adventure)">
                                  {{'game.start' | translate}}
                                </div>
                              }
                              <div class="tip-txt">{{ adventure?.adventure_price_msg }}</div>
                            </div>
                          </ion-col>
                        </ion-row>
                      </ng-template>
                    }
                    @if (adventure?.userAdventure?.adventure_mod?.toLowerCase() === 'inprogress') {
                      <ng-template swiperSlide class="slide-wrapper card-2">
                        <div class="adventure-header">
                          <h4 class="card-title">
                            {{adventure?.country_code_data?.[preferredCurrency=='CAD'? 1 : preferredCurrency=='EUR'? 353 :
                            44]?.adventure_title}}
                          </h4>
                        </div>
                        <ion-row class="adventure-row">
                          <ion-col class="img-col">
                            <img (click)="openAdventureDetails(adventure?.adventure_id)" [src]="adventure.adventure_gif_image"
                              alt="" class="gamz-img" />
                              <div class="prize-wrap">
                                <img src="assets/images/discount.png" alt="" class="prize-img" />
                                <div class="prize-txt">
                                  {{'game.Prizes' | translate}}<br />
                                  {{ adventure?.country_code_data?.[preferredCurrency=='CAD'? 1 : preferredCurrency=='EUR'? 353 :
                                  44]?.total_prize }}
                                </div>
                              </div>
                            </ion-col>
                            <ion-col class="details-col">
                              <p class="desc-p">
                                {{'game.achieved' | translate}} <b>{{ adventure?.userAdventure?.star_collected }}</b><img
                                src="assets/images/small-star.svg" class="small-star" />
                              </p>
                              <div class="game-boxs">
                                <div class="box-card">
                                  <img src="assets/images/blue_shield.png" class="box-img" />
                                </div>
                                <div class="box-cash">
                                  <label class="cash-title">{{ adventure?.general_prize}}</label>
                                  <span class="cash-sbtxt">{{ adventure?.userAdventure?.prize_details?.prize_text }}</span>
                                </div>
                              </div>
                              <div class="star-wrap">
                                <div class="star-badge">
                                  {{ adventure?.userAdventure?.prize_details?.star_required }} {{'game.stars' | translate}}
                                </div>
                              </div>
                              <div class="progress-bar-wrap">
                                <ion-progress-bar color="dark" class="progress-bar"
                                value="{{ adventure?.userAdventure?.prize_details?.percentage / 100 }}"></ion-progress-bar>
                              </div>
                              <div class="bottow-wrap">
                                @if (inProgressQuit) {
                                  <ion-spinner name="lines-small" class="sign-in-spinner" duration="2000"
                                  style="color: blue; margin-right: 1vh"></ion-spinner>
                                }
                                @if (adventure.inProgress) {
                                  <ion-spinner name="lines-small" class="sign-in-spinner"
                                  duration="2000" style="color: blue; margin-right: 1vh"></ion-spinner>
                                }
                                @if (!adventure.inProgress) {
                                  <div class="start-badge" (click)="startAdventure(adventure)">
                                    {{'game.Continue' | translate}}
                                  </div>
                                }
                              </div>
                            </ion-col>
                          </ion-row>
                        </ng-template>
                      }
                      @if (adventure?.userAdventure?.adventure_mod?.toLowerCase() === 'locked') {
                        <ng-template swiperSlide class="slide-wrapper card-3">
                          <div class="slider-overlay">
                            <button class="lock-btn">
                              <img src="assets/images/lock.svg" class="lock-ic" />{{'game.Locked' | translate}}
                            </button>
                          </div>
                          <h4 class="card-title">
                            {{adventure?.country_code_data?.[preferredCurrency=='CAD'? 1 : preferredCurrency=='EUR'? 353 :
                            44]?.adventure_title}}
                          </h4>
                          <ion-row class="adventure-row">
                            <ion-col class="img-col">
                              <img (click)="openAdventureDetails(adventure?.adventure_id)" [src]="adventure.adventure_image_url"
                                alt="" class="gamz-img" />
                                <div class="prize-wrap">
                                  <img src="assets/images/discount.png" alt="" class="prize-img" />
                                  <div class="prize-txt">
                                    {{'game.Prizes' | translate}}<br />
                                    {{ adventure?.general_total_prize }}
                                  </div>
                                </div>
                              </ion-col>
                              <ion-col class="details-col">
                                <p class="desc-p">{{'game.adventure' | translate}}</p>
                                <div class="game-boxs">
                                  <div class="box-card">
                                    <img src="assets/images/header.jpg" alt="" class="box-img" />
                                  </div>
                                  <div class="box-card">
                                    <img
                                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcR3oi_Yy-edbBo1Rh74c-cwW3GJJZxvrkTeFQ&usqp=CAU"
                                      alt="" class="box-img" />
                                    </div>
                                    <div class="box-card">
                                      <img
                                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSHHM6kjH4djncaxmaTUdt4AYpoFDed3vdSYw&usqp=CAU"
                                        alt="" class="box-img" />
                                      </div>
                                      <div class="box-card">
                                        <img
                                          src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSHHM6kjH4djncaxmaTUdt4AYpoFDed3vdSYw&usqp=CAU"
                                          alt="" class="box-img" />
                                        </div>
                                      </div>
                                      <div class="bottow-wrap">
                                        @if (inProgress) {
                                          <ion-spinner name="lines-small" class="sign-in-spinner" duration="2000"
                                          style="color: blue; margin-right: 1vh"></ion-spinner>
                                        }
                                        @if (!inProgress) {
                                          <div class="start-badge" (click)="startAdventure(adventure)">
                                            {{'game.start' | translate}}
                                          </div>
                                        }
                                        <div class="tip-txt">{{ adventure?.adventure_price_msg }}</div>
                                      </div>
                                    </ion-col>
                                  </ion-row>
                                </ng-template>
                              }
                              @if (adventure?.userAdventure?.adventure_mod?.toLowerCase() === 'complete') {
                                <ng-template swiperSlide class="slide-wrapper card-4">
                                  <h4 class="card-title">
                                    {{adventure?.country_code_data?.[preferredCurrency=='CAD'? 1 : preferredCurrency=='EUR'? 353 :
                                    44]?.adventure_title}}
                                  </h4>
                                  <ion-row class="adventure-row">
                                    <ion-col class="img-col">
                                      <img [src]="adventure.adventure_image_url" alt="" class="gamz-img" />
                                      <div class="prize-wrap">
                                        <img (click)="openAdventureDetails(adventure?.adventure_id)" src="assets/images/discount.png"
                                          alt="" class="prize-img" />
                                          <div class="prize-txt">
                                            {{'game.Prizes' | translate}}<br />
                                            {{ adventure?.general_total_prize }}
                                          </div>
                                        </div>
                                      </ion-col>
                                      <ion-col class="details-col">
                                        <p class="desc-p">{{'game.Congratulations' | translate}}</p>
                                        <p class="sub-desc-p">
                                          {{'game.achieved' | translate}} <b>{{ adventure?.userAdventure?.star_collected }}</b><img
                                          src="assets/images/small-star.svg" class="small-star" />
                                        </p>
                                        <div class="game-boxs">
                                          @for (prize of adventure?.userAdventure?.prize_details; track prize) {
                                            <div class="box-card">
                                              <img [src]="prize.image_url" alt="" class="box-img" />
                                              <div class="shield-price">{{ prize?.prize_amount }}</div>
                                            </div>
                                          }
                                        </div>
                                      </ion-col>
                                    </ion-row>
                                  </ng-template>
                                }
                              }
                            </swiper>
                          }
                        </ion-row>
                      } @else {
                        <ion-row ion-row class="adventures-card">
                          <app-in-progress-animation type="loadingadventures"></app-in-progress-animation>
                        </ion-row>
                      }
                      <!-- Pagination -->
                      <div class="nav-icon">
                        <div class="navigation-arrows">
                          <button (click)="prev('adventureGame')" class="nav-prev-icon">
                            <ion-icon name="chevron-back-outline"></ion-icon>
                          </button>
                        </div>
                        <div class="navigation-arrows">
                          <div class="swiper-pagination-two"></div>
                        </div>
                        <div class="navigation-arrows">
                          <button (click)="next('adventureGame')" class="nav-next-icon">
                            <ion-icon name="chevron-forward-outline"></ion-icon>
                          </button>
                        </div>
                      </div>

                      @if (instantWins$ | async; as instantWins) {
                        <ion-row class="prize-card-wrapper instant-card">
                          <h3 class="title-heading">{{instantWins?.title}}</h3>
                          <h4 class="sub-heading">{{instantWins?.sub_title}}</h4>
                          <ion-row class="game-slide-row">
                            <swiper class="game-slider" [config]="instantWinSlider" #instantWinSlide>
                              @for (instantWin of (instantWins.games | filterYoursToPlay : 3) ; track instantWin; let i = $index) {
                                <ng-template swiperSlide
                                  >
                                  <div class="item-card-container">
                                    @for (instantGame of instantWin; track instantGame) {
                                      <ion-row class="item-row" (click)="openPopup($event, instantGame)">
                                        <ion-col class="item-icon">
                                          <img src="{{instantGame?.game_icon_url}}" class="item-img" />
                                        </ion-col>
                                        <ion-col class="item-details">
                                          <ion-row class="item-detail-row">
                                            <ion-col class="item-left">
                                              <h5 class="item-title" (click)="openPopup($event, instantGame)">{{instantGame?.game_title}}</h5>
                                              <p class="item-p">{{ instantGame?.gameShortTitle}}</p>
                                            </ion-col>
                                            <ion-col class="item-right">
                                              <div class="prize-txt">Prize</div>
                                              @if (instantGame?.country_code_data['44']?.game_title!=starDisplay) {
                                                <div class="money-bag">
                                                  <img src="assets/images/money-dollar.png" class="money-bag-img" />
                                                </div>
                                              }
                                              @if (instantGame?.country_code_data['44']?.game_title==starDisplay) {
                                                <div class="money-bag">
                                                  <img src="assets/images/star.svg" class="money-bag-img" />
                                                </div>
                                              }
                                              <div class="dollar-wrap">{{ instantGame?.gameTopPrice?.toString().replace("Cash", "") }}</div>
                                            </ion-col>
                                          </ion-row>
                                        </ion-col>
                                      </ion-row>
                                    }
                                  </div>
                                </ng-template>
                              }
                            </swiper>
                          </ion-row>
                        </ion-row>
                      } @else {
                        <ion-row ion-row class="prize-card-wrapper instant-card">
                          <app-in-progress-animation type="loadingcommon"></app-in-progress-animation>
                        </ion-row>
                      }
                      <!-- Pagination -->

                      <div class="nav-icon">
                        <div class="navigation-arrows">
                          <button (click)="prev('instantWin')" class="nav-prev-icon">
                            <ion-icon name="chevron-back-outline"></ion-icon>
                          </button>
                        </div>
                        <div class="navigation-arrows">
                          <div class="swiper-pagination-four"></div>
                        </div>
                        <div class="navigation-arrows">
                          <button (click)="next('instantWin')" class="nav-next-icon">
                            <ion-icon name="chevron-forward-outline"></ion-icon>
                          </button>
                        </div>
                      </div>

                      @if (skillGames$ | async; as skillGames) {
                        <ion-row class="prize-card-wrapper skill-card">
                          <h3 class="title-heading">{{skillGames?.title}}</h3>
                          <h4 class="sub-heading">{{skillGames?.sub_title}}</h4>
                          <ion-row class="game-slide-row">
                            <swiper class="game-slider" [config]="SkilledgameslideOpts" #skilledGameSlider>
                              @for (skill of (skillGames?.games | filterYoursToPlay : 3) ; track skill; let i = $index) {
                                <ng-template swiperSlide>
                                  <div class="item-card-container">
                                    @for (skillPlay of skill; track skillPlay) {
                                      <ion-row class="item-row" (click)="openPopup($event, skillPlay)">
                                        <ion-col class="item-icon">
                                          <img src="{{skillPlay?.game_icon_url}}" class="item-img" />
                                        </ion-col>
                                        <ion-col class="item-details">
                                          <ion-row class="item-detail-row">
                                            <ion-col class="item-left">
                                              <h5 class="item-title" (click)="openPopup($event, skillPlay)">{{skillPlay?.game_title}}</h5>
                                              <p class="item-p">{{skillPlay?.game_short_title}}</p>
                                            </ion-col>
                                            <ion-col class="item-right">
                                              <div class="prize-txt">Prize</div>
                                              <div class="money-bag">
                                                <img src="assets/images/money-dollar.png" class="money-bag-img" />
                                              </div>
                                              <div class="dollar-wrap">{{skillPlay?.total_prize}}</div>
                                            </ion-col>
                                          </ion-row>
                                        </ion-col>
                                      </ion-row>
                                    }
                                  </div>
                                </ng-template>
                              }
                            </swiper>
                          </ion-row>
                        </ion-row>
                      } @else {
                        <ion-row ion-row class="prize-card-wrapper skill-card">
                          <app-in-progress-animation type="loadingcommon"></app-in-progress-animation>
                        </ion-row>
                      }
                      <!-- Pagination -->
                      <div class="nav-icon skillGame">
                        <div class="navigation-arrows">
                          <button (click)="prev('skilledGame')" class="nav-prev-icon">
                            <ion-icon name="chevron-back-outline"></ion-icon>
                          </button>
                        </div>
                        <div class="navigation-arrows">
                          <div class="swiper-pagination-three"></div>
                        </div>
                        <div class="navigation-arrows">
                          <button (click)="next('skilledGame')" class="nav-next-icon">
                            <ion-icon name="chevron-forward-outline"></ion-icon>
                          </button>
                        </div>
                      </div>
                    </ion-grid>
                  </ion-content>